export const JURISDICTION_LIST: { code: string; title: string }[] = [
  {
    code: 'AD',
    title: 'Andorra',
  },
  {
    code: 'AE',
    title: 'United Arab Emirates',
  },
  {
    code: 'AF',
    title: 'Afghanistan',
  },
  {
    code: 'AG',
    title: 'Antigua and Barbuda',
  },
  {
    code: 'AI',
    title: 'Anguilla',
  },
  {
    code: 'AL',
    title: 'Albania',
  },
  {
    code: 'AM',
    title: 'Armenia',
  },
  {
    code: 'AO',
    title: 'Angola',
  },
  {
    code: 'AQ',
    title: 'Antarctica',
  },
  {
    code: 'AR',
    title: 'Argentina',
  },
  {
    code: 'AS',
    title: 'American Samoa',
  },
  {
    code: 'AT',
    title: 'Austria',
  },
  {
    code: 'AU',
    title: 'Australia',
  },
  {
    code: 'AW',
    title: 'Aruba',
  },
  {
    code: 'AX',
    title: 'Åland',
  },
  {
    code: 'AZ',
    title: 'Azerbaijan',
  },
  {
    code: 'BA',
    title: 'Bosnia and Herzegovina',
  },
  {
    code: 'BB',
    title: 'Barbados',
  },
  {
    code: 'BD',
    title: 'Bangladesh',
  },
  {
    code: 'BE',
    title: 'Belgium',
  },
  {
    code: 'BF',
    title: 'Burkina Faso',
  },
  {
    code: 'BG',
    title: 'Bulgaria',
  },
  {
    code: 'BH',
    title: 'Bahrain',
  },
  {
    code: 'BI',
    title: 'Burundi',
  },
  {
    code: 'BJ',
    title: 'Benin',
  },
  {
    code: 'BL',
    title: 'Saint Barthélemy',
  },
  {
    code: 'BM',
    title: 'Bermuda',
  },
  {
    code: 'BN',
    title: 'Brunei Darussalam',
  },
  {
    code: 'BO',
    title: 'Bolivia',
  },
  {
    code: 'BQ',
    title: 'Bonaire, Saint Eustatius and Saba',
  },
  {
    code: 'BR',
    title: 'Brazil',
  },
  {
    code: 'BS',
    title: 'Bahamas',
  },
  {
    code: 'BT',
    title: 'Bhutan',
  },
  {
    code: 'BV',
    title: 'Bouvet Island',
  },
  {
    code: 'BW',
    title: 'Botswana',
  },
  {
    code: 'BY',
    title: 'Belarus',
  },
  {
    code: 'BZ',
    title: 'Belize',
  },
  {
    code: 'CA',
    title: 'Canada',
  },
  {
    code: 'CC',
    title: 'Cocos (Keeling) Islands',
  },
  {
    code: 'CD',
    title: 'Democratic Republic of the Congo',
  },
  {
    code: 'CF',
    title: 'Central African Republic',
  },
  {
    code: 'CG',
    title: 'Congo',
  },
  {
    code: 'CH',
    title: 'Switzerland',
  },
  {
    code: 'CI',
    title: "Côte d'Ivoire",
  },
  {
    code: 'CK',
    title: 'Cook Islands',
  },
  {
    code: 'CL',
    title: 'Chile',
  },
  {
    code: 'CM',
    title: 'Cameroon',
  },
  {
    code: 'CN',
    title: 'China',
  },
  {
    code: 'CO',
    title: 'Colombia',
  },
  {
    code: 'CR',
    title: 'Costa Rica',
  },
  {
    code: 'CU',
    title: 'Cuba',
  },
  {
    code: 'CV',
    title: 'Cape Verde',
  },
  {
    code: 'CW',
    title: 'Curaçao',
  },
  {
    code: 'CX',
    title: 'Christmas Island',
  },
  {
    code: 'CY',
    title: 'Cyprus',
  },
  {
    code: 'CZ',
    title: 'Czechia',
  },
  {
    code: 'DE',
    title: 'Germany',
  },
  {
    code: 'DJ',
    title: 'Djibouti',
  },
  {
    code: 'DK',
    title: 'Denmark',
  },
  {
    code: 'DM',
    title: 'Dominica',
  },
  {
    code: 'DO',
    title: 'Dominican Republic',
  },
  {
    code: 'DZ',
    title: 'Algeria',
  },
  {
    code: 'EC',
    title: 'Ecuador',
  },
  {
    code: 'EE',
    title: 'Estonia',
  },
  {
    code: 'EG',
    title: 'Egypt',
  },
  {
    code: 'EH',
    title: 'Western Sahara',
  },
  {
    code: 'ER',
    title: 'Eritrea',
  },
  {
    code: 'ES',
    title: 'Spain',
  },
  {
    code: 'ET',
    title: 'Ethiopia',
  },
  {
    code: 'EU',
    title: 'Europe',
  },
  {
    code: 'FI',
    title: 'Finland',
  },
  {
    code: 'FJ',
    title: 'Fiji',
  },
  {
    code: 'FK',
    title: 'Falkland Islands',
  },
  {
    code: 'FM',
    title: 'Micronesia',
  },
  {
    code: 'FO',
    title: 'Faroe Islands',
  },
  {
    code: 'FR',
    title: 'France',
  },
  {
    code: 'GA',
    title: 'Gabon',
  },
  {
    code: 'GB',
    title: 'United Kingdom',
  },
  {
    code: 'GD',
    title: 'Grenada',
  },
  {
    code: 'GE',
    title: 'Georgia',
  },
  {
    code: 'GF',
    title: 'French Guiana',
  },
  {
    code: 'GG',
    title: 'Guernsey',
  },
  {
    code: 'GH',
    title: 'Ghana',
  },
  {
    code: 'GI',
    title: 'Gibraltar',
  },
  {
    code: 'GL',
    title: 'Greenland',
  },
  {
    code: 'GM',
    title: 'Gambia',
  },
  {
    code: 'GN',
    title: 'Guinea',
  },
  {
    code: 'GP',
    title: 'Guadeloupe',
  },
  {
    code: 'GQ',
    title: 'Equatorial Guinea',
  },
  {
    code: 'GR',
    title: 'Greece',
  },
  {
    code: 'GS',
    title: 'South Georgia and South Sandwich Islands',
  },
  {
    code: 'GT',
    title: 'Guatemala',
  },
  {
    code: 'GU',
    title: 'Guam',
  },
  {
    code: 'GW',
    title: 'Guinea-Bissau',
  },
  {
    code: 'GY',
    title: 'Guyana',
  },
  {
    code: 'HK',
    title: 'Hong Kong',
  },
  {
    code: 'HM',
    title: 'Heard Island and McDonald Islands',
  },
  {
    code: 'HN',
    title: 'Honduras',
  },
  {
    code: 'HR',
    title: 'Croatia',
  },
  {
    code: 'HT',
    title: 'Haiti',
  },
  {
    code: 'HU',
    title: 'Hungary',
  },
  {
    code: 'ID',
    title: 'Indonesia',
  },
  {
    code: 'IE',
    title: 'Ireland',
  },
  {
    code: 'IL',
    title: 'Israel',
  },
  {
    code: 'IM',
    title: 'Isle of Man',
  },
  {
    code: 'IN',
    title: 'India',
  },
  {
    code: 'IO',
    title: 'British Indian Ocean Territory',
  },
  {
    code: 'IQ',
    title: 'Iraq',
  },
  {
    code: 'IR',
    title: 'Iran',
  },
  {
    code: 'IS',
    title: 'Iceland',
  },
  {
    code: 'IT',
    title: 'Italy',
  },
  {
    code: 'JE',
    title: 'Jersey',
  },
  {
    code: 'JM',
    title: 'Jamaica',
  },
  {
    code: 'JO',
    title: 'Jordan',
  },
  {
    code: 'JP',
    title: 'Japan',
  },
  {
    code: 'KE',
    title: 'Kenya',
  },
  {
    code: 'KG',
    title: 'Kyrgyzstan',
  },
  {
    code: 'KH',
    title: 'Cambodia',
  },
  {
    code: 'KI',
    title: 'Kiribati',
  },
  {
    code: 'KM',
    title: 'Comoros',
  },
  {
    code: 'KN',
    title: 'Saint Kitts and Nevis',
  },
  {
    code: 'KP',
    title: 'Korea, North',
  },
  {
    code: 'KR',
    title: 'Korea, South',
  },
  {
    code: 'KW',
    title: 'Kuwait',
  },
  {
    code: 'KY',
    title: 'Cayman Islands',
  },
  {
    code: 'KZ',
    title: 'Kazakhstan',
  },
  {
    code: 'LA',
    title: 'Laos',
  },
  {
    code: 'LB',
    title: 'Lebanon',
  },
  {
    code: 'LC',
    title: 'Saint Lucia',
  },
  {
    code: 'LI',
    title: 'Liechtenstein',
  },
  {
    code: 'LK',
    title: 'Sri Lanka',
  },
  {
    code: 'LR',
    title: 'Liberia',
  },
  {
    code: 'LS',
    title: 'Lesotho',
  },
  {
    code: 'LT',
    title: 'Lithuania',
  },
  {
    code: 'LU',
    title: 'Luxembourg',
  },
  {
    code: 'LV',
    title: 'Latvia',
  },
  {
    code: 'LY',
    title: 'Libya',
  },
  {
    code: 'MA',
    title: 'Morocco',
  },
  {
    code: 'MC',
    title: 'Monaco',
  },
  {
    code: 'MD',
    title: 'Moldova',
  },
  {
    code: 'ME',
    title: 'Montenegro',
  },
  {
    code: 'MF',
    title: 'Saint Martin (French part)',
  },
  {
    code: 'MG',
    title: 'Madagascar',
  },
  {
    code: 'MH',
    title: 'Marshall Islands',
  },
  {
    code: 'MK',
    title: 'North Macedonia',
  },
  {
    code: 'ML',
    title: 'Mali',
  },
  {
    code: 'MM',
    title: 'Myanmar',
  },
  {
    code: 'MN',
    title: 'Mongolia',
  },
  {
    code: 'MO',
    title: 'Macau',
  },
  {
    code: 'MP',
    title: 'Northern Mariana Islands',
  },
  {
    code: 'MQ',
    title: 'Martinique',
  },
  {
    code: 'MR',
    title: 'Mauritania',
  },
  {
    code: 'MS',
    title: 'Montserrat',
  },
  {
    code: 'MT',
    title: 'Malta',
  },
  {
    code: 'MU',
    title: 'Mauritius',
  },
  {
    code: 'MV',
    title: 'Maldives',
  },
  {
    code: 'MW',
    title: 'Malawi',
  },
  {
    code: 'MX',
    title: 'Mexico',
  },
  {
    code: 'MY',
    title: 'Malaysia',
  },
  {
    code: 'MZ',
    title: 'Mozambique',
  },
  {
    code: 'NA',
    title: 'Namibia',
  },
  {
    code: 'NC',
    title: 'New Caledonia',
  },
  {
    code: 'NE',
    title: 'Niger',
  },
  {
    code: 'NF',
    title: 'Norfolk Island',
  },
  {
    code: 'NG',
    title: 'Nigeria',
  },
  {
    code: 'NI',
    title: 'Nicaragua',
  },
  {
    code: 'NL',
    title: 'Netherlands',
  },
  {
    code: 'NO',
    title: 'Norway',
  },
  {
    code: 'NP',
    title: 'Nepal',
  },
  {
    code: 'NR',
    title: 'Nauru',
  },
  {
    code: 'NU',
    title: 'Niue',
  },
  {
    code: 'NZ',
    title: 'New Zealand',
  },
  {
    code: 'OM',
    title: 'Oman',
  },
  {
    code: 'PA',
    title: 'Panama',
  },
  {
    code: 'PE',
    title: 'Peru',
  },
  {
    code: 'PF',
    title: 'French Polynesia',
  },
  {
    code: 'PG',
    title: 'Papua New Guinea',
  },
  {
    code: 'PH',
    title: 'Philippines',
  },
  {
    code: 'PK',
    title: 'Pakistan',
  },
  {
    code: 'PL',
    title: 'Poland',
  },
  {
    code: 'PM',
    title: 'Saint Pierre and Miquelon',
  },
  {
    code: 'PN',
    title: 'Pitcairn',
  },
  {
    code: 'PR',
    title: 'Puerto Rico',
  },
  {
    code: 'PS',
    title: 'Palestine',
  },
  {
    code: 'PT',
    title: 'Portugal',
  },
  {
    code: 'PW',
    title: 'Palau',
  },
  {
    code: 'PY',
    title: 'Paraguay',
  },
  {
    code: 'QA',
    title: 'Qatar',
  },
  {
    code: 'RE',
    title: 'Reunion',
  },
  {
    code: 'RO',
    title: 'Romania',
  },
  {
    code: 'RS',
    title: 'Serbia',
  },
  {
    code: 'RU',
    title: 'Russian Federation',
  },
  {
    code: 'RW',
    title: 'Rwanda',
  },
  {
    code: 'SA',
    title: 'Saudi Arabia',
  },
  {
    code: 'SB',
    title: 'Solomon Islands',
  },
  {
    code: 'SC',
    title: 'Seychelles',
  },
  {
    code: 'SD',
    title: 'Sudan',
  },
  {
    code: 'SE',
    title: 'Sweden',
  },
  {
    code: 'SG',
    title: 'Singapore',
  },
  {
    code: 'SH',
    title: 'Saint Helena',
  },
  {
    code: 'SI',
    title: 'Slovenia',
  },
  {
    code: 'SJ',
    title: 'Svalbard and Jan Mayen Islands',
  },
  {
    code: 'SK',
    title: 'Slovakia',
  },
  {
    code: 'SL',
    title: 'Sierra Leone',
  },
  {
    code: 'SM',
    title: 'San Marino',
  },
  {
    code: 'SN',
    title: 'Senegal',
  },
  {
    code: 'SO',
    title: 'Somalia',
  },
  {
    code: 'SR',
    title: 'Suriname',
  },
  {
    code: 'SS',
    title: 'South Sudan',
  },
  {
    code: 'ST',
    title: 'Sao Tome and Principe',
  },
  {
    code: 'SV',
    title: 'El Salvador',
  },
  {
    code: 'SX',
    title: 'Sint Maarten',
  },
  {
    code: 'SY',
    title: 'Syria',
  },
  {
    code: 'SZ',
    title: 'Swaziland',
  },
  {
    code: 'TC',
    title: 'Turks and Caicos Islands',
  },
  {
    code: 'TD',
    title: 'Chad',
  },
  {
    code: 'TF',
    title: 'French Southern Lands',
  },
  {
    code: 'TG',
    title: 'Togo',
  },
  {
    code: 'TH',
    title: 'Thailand',
  },
  {
    code: 'TJ',
    title: 'Tajikistan',
  },
  {
    code: 'TK',
    title: 'Tokelau',
  },
  {
    code: 'TL',
    title: 'Timor-Leste',
  },
  {
    code: 'TM',
    title: 'Turkmenistan',
  },
  {
    code: 'TN',
    title: 'Tunisia',
  },
  {
    code: 'TO',
    title: 'Tonga',
  },
  {
    code: 'TR',
    title: 'Turkey',
  },
  {
    code: 'TT',
    title: 'Trinidad and Tobago',
  },
  {
    code: 'TV',
    title: 'Tuvalu',
  },
  {
    code: 'TW',
    title: 'Taiwan',
  },
  {
    code: 'TZ',
    title: 'Tanzania',
  },
  {
    code: 'UA',
    title: 'Ukraine',
  },
  {
    code: 'UG',
    title: 'Uganda',
  },
  {
    code: 'UM',
    title: 'United States Minor Outlying Islands',
  },
  {
    code: 'US',
    title: 'United States of America',
  },
  {
    code: 'UY',
    title: 'Uruguay',
  },
  {
    code: 'UZ',
    title: 'Uzbekistan',
  },
  {
    code: 'VA',
    title: 'Vatican City',
  },
  {
    code: 'VC',
    title: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'VE',
    title: 'Venezuela',
  },
  {
    code: 'VG',
    title: 'Virgin Islands, British',
  },
  {
    code: 'VI',
    title: 'Virgin Islands, U.S.',
  },
  {
    code: 'VU',
    title: 'Vanuatu',
  },
  {
    code: 'WF',
    title: 'Wallis and Futuna Islands',
  },
  {
    code: 'WS',
    title: 'Samoa',
  },
  {
    code: 'XK',
    title: 'Kosovo (under UNSCR 1244/99)',
  },
  {
    code: 'YE',
    title: 'Yemen',
  },
  {
    code: 'YT',
    title: 'Mayotte',
  },
  {
    code: 'ZA',
    title: 'South Africa',
  },
  {
    code: 'ZM',
    title: 'Zambia',
  },
  {
    code: 'ZW',
    title: 'Zimbabwe',
  },
];

export const CURRENCY_OPTIONS = [
  { value: 'EUR', label: 'EUR', symbol: '€' },
  { value: 'USD', label: 'USD', symbol: '$' },
  { value: 'GBP', label: 'GBP', symbol: '£' },
];

export const TIME = {
  MS: {
    MINUTE: 60 * 1000,
    HOUR: 60 * 60 * 1000,
    DAY: 24 * 60 * 60 * 1000,
    WEEK: 7 * 24 * 60 * 60 * 1000,
    MONTH: 30 * 24 * 60 * 60 * 1000,
    YEAR: 365 * 24 * 60 * 60 * 1000,
  },
  SECONDS: {
    MINUTE: 60,
    HOUR: 60 * 60,
    DAY: 24 * 60 * 60,
    WEEK: 7 * 24 * 60 * 60,
    MONTH: 30 * 24 * 60 * 60,
    YEAR: 365 * 24 * 60 * 60,
  },
};
